<form name="preCheckout" class="form-group needs-validation" [formGroup]="preCheckoutForm" (ngSubmit)="onSubmit()" novalidate>
    <label [class.label-invalid]="!validForm()" translate>preCheckout.cpf</label>
    <div class="d-flex align-items-center pb input-group has-validations">
        <input class="form-control" aria-describedby="basic-cpf" type="text" placeholder=" " formControlName="cpf" id="cpf" mask="000.000.000-00" 
        [class.input-invalid]="invalidCpf()" required appCpfValidate/>
        
        <div class="input-group-append">
            <span class="input-group-text" id="basic-cpf">
                <fa-icon class="float-end" [icon]="['fas', 'user']" size="lg"></fa-icon>
            </span>
        </div>
        <div class="invalid-feedback" translate>
            preCheckout.cpfRequired
        </div>
        <div *ngIf="invalidCpf()" class="error" translate>
            preCheckout.invalidCpf
        </div>
    </div>
    <div class="pb col text-center">
        <button type="submit" class="btn btn-success custom-button" translate="" [disabled]="!validForm()">preCheckout.button</button>
    </div>
</form>